import SimplexNoise from 'simplex-noise'
import { truchet, pattern } from './truchet'
import createArray from './createArray'

const getPattern = (ps) =>
    Object.keys(ps)
        .filter((i) => ps[i])
        .map((i) => pattern[i])

export default ({
    seed,
    noiseRatioX,
    noiseRatioY,
    noiseFormRatioX,
    noiseFormRatioY,
    pattern,
    maxDepth = 4,
    colors,
}) =>
    truchet({
        size: 200,
        maxDepth,
        width: 4,
        cnt: Math.pow(4, 2),
        simplex: new SimplexNoise(seed),
        noiseRatioX,
        noiseRatioY,
        seed,
        noiseFormRatioX,
        noiseFormRatioY,
        pattern: getPattern(pattern),
        colors,
    })
        .flat(maxDepth)
        .reduce(
            (acc, { depth, ...l }) => (acc[depth].push(l), acc),
            createArray(() => [], maxDepth + 2)
        )
